module.exports = __webpack_public_path__ + "assets/kidneys.8df29f0c.svg";